import { render, staticRenderFns } from "./home.vue?vue&type=template&id=31f28818&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "../../assets/commoon/css/common.css?vue&type=style&index=0&id=31f28818&prod&scoped=true&lang=css&external"
import style1 from "./home.vue?vue&type=style&index=1&id=31f28818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f28818",
  null
  
)

export default component.exports